import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import ButtonConfigurator from './ButtonConfigurator';
import type { ButtonCustomization } from '../../lib/types';

interface ConfigurationDemoProps {
  onConfigChange: (config: ButtonCustomization) => void;
}

const ConfigurationDemo: React.FC<ConfigurationDemoProps> = ({ onConfigChange }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-3">
          <span className="text-xl font-semibold text-gray-900">
            Customize Your Button
          </span>
        </div>
        <ChevronDown
          className={`w-5 h-5 text-gray-500 transition-transform ${
            isOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>

      {isOpen && (
        <div className="px-6 py-4 border-t border-gray-200">
          <ButtonConfigurator onConfigChange={onConfigChange} />
        </div>
      )}
    </div>
  );
};

export default ConfigurationDemo;